import { Video, AudioLines, Image, FileArchive } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { ToolCard } from '@/components/tools/tool-card'
import { useI18n } from '@/lib/i18n'

interface ToolEntry {
  titleKey: 'toolVideo' | 'toolAudio' | 'toolImage' | 'toolZip'
  descKey: 'toolVideoDesc' | 'toolAudioDesc' | 'toolImageDesc' | 'toolZipDesc'
  href: string
  icon: LucideIcon
  formats: readonly string[]
}

const TOOLS: readonly ToolEntry[] = [
  {
    titleKey: 'toolVideo',
    descKey: 'toolVideoDesc',
    href: '/tools/video-converter',
    icon: Video,
    formats: ['MP4', 'MOV', 'MKV', 'WEBM'],
  },
  {
    titleKey: 'toolAudio',
    descKey: 'toolAudioDesc',
    href: '/tools/audio-converter',
    icon: AudioLines,
    formats: ['MP3', 'WAV', 'AAC'],
  },
  {
    titleKey: 'toolImage',
    descKey: 'toolImageDesc',
    href: '/tools/image-compressor',
    icon: Image,
    formats: ['JPG', 'PNG', 'WEBP'],
  },
  {
    titleKey: 'toolZip',
    descKey: 'toolZipDesc',
    href: '/tools/zip',
    icon: FileArchive,
    formats: ['ZIP'],
  },
]

/** Bento grid of tool entry cards. */
export function ToolsSection() {
  const { t, path } = useI18n()

  return (
    <section id="tools" className="border-t bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{t('homeToolsTitle')}</h2>
          <p className="mt-4 text-lg text-muted-foreground">{t('homeToolsSubtitle')}</p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {TOOLS.map((tool) => (
            <ToolCard
              key={tool.href}
              title={t(tool.titleKey)}
              description={t(tool.descKey)}
              href={path(tool.href)}
              icon={tool.icon}
              formats={tool.formats}
            />
          ))}
        </div>
      </div>
    </section>
  )
}